<template>
    <div class="annt-doc-wrapper">
        <el-dropdown ref="dropdownRef" class="lang-seletor" trigger="click" v-if="isLogin">
            <el-button ref="triggerRef" type="text" icon="el-icon-sort" class="accounting-entity-btn">
                <!-- <i class="icon iconfont icon-sort-plan"></i> -->
                <span class="entity-name">{{ currentCustomerName || '请选择货主' }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <template #dropdown>
                <el-dropdown-menu class="doc-dropdown">
                    <el-dropdown-item
                        @click="toSwitchOwner(item)"
                        v-for="item in ownerList"
                        :key="item.anhzCode"
                        :command="item.anhzCode">
                        {{ item.abbreviation ? item.abbreviation : item.customerName }}
                        <i v-if="item.anhzCode === currentCustomerAnhzCode" class="el-icon-check"></i>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
    </div>
</template>
<script>
import { reactive, toRefs, computed, ref, watch } from 'vue'
import { getCargoOwnerInfo, setToken, setCargoOwnerInfo, getToken } from '@/utils/auth'
import { formatLoginInfo } from '@/utils/index'
import { switchOwner } from '@/api/login.js'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
    name: 'SwitchOwner',
    setup() {
        const isLogin = getToken()
        const store = useStore()
        const router = useRouter()
        const dropdownRef = ref(null)
        const triggerRef = ref(null)
        /** 数据 */
        const state = reactive({
            ownerList: JSON.parse(getCargoOwnerInfo()), // 货主列表
        })

        /** 监听 checkMip 无已签约主体弹窗标志，展开货主下拉框 */
        watch(
            () => store.getters.cargoOwnerDropdownVisible,
            val => {
                if (val) {
                    const triggerBtn = triggerRef.value?.$el
                    triggerBtn?.click()
                    store.commit('updateCargoOwnerDropdownVisible', false)
                }
            },
        )

        /* 获取当前货主 */
        const getCurrentOwner = () => {
            return formatLoginInfo(JSON.parse(getCargoOwnerInfo()))
        }

        const currentCustomerName = computed(() => {
            const currOwner = getCurrentOwner()
            return currOwner?.abbreviation || currOwner?.customerName
        })

        const currentCustomerAnhzCode = computed(() => getCurrentOwner()?.anhzCode)

        /* 切换货主 */
        const toSwitchOwner = item => {
            if (item.anhzCode === currentCustomerAnhzCode.value) return

            item.mobile = store.state.user.user.contactsMobile
            switchOwner(item).then(res => {
                if (res && +res.code === 0) {
                    setToken(res.data.token)
                    for (const key in state.ownerList) {
                        if (state.ownerList[key].anhzCode) {
                            // eslint-disable-next-line max-depth
                            if (state.ownerList[key].anhzCode === item.anhzCode) {
                                state.ownerList[key].flag = 0
                            } else {
                                state.ownerList[key].flag = null
                            }
                        }
                    }
                    setCargoOwnerInfo(JSON.stringify(state.ownerList))
                    router.push('/')
                    location.reload()
                }
            })
        }
        return {
            ...toRefs(state),
            currentCustomerName,
            currentCustomerAnhzCode,
            toSwitchOwner,
            store,
            router,
            isLogin,
            dropdownRef,
            triggerRef,
        }
    },
}
</script>
<style lang="less">
.annt-doc-wrapper {
    .icon-button {
        font-size: 14px;
    }
}

.doc-dropdown {
    padding: 8px 0;

    li {
        padding: 4px 16px;
    }
}
</style>
